// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import {
  CreateCustomerRequest,
  Customer,
  CustomerStatus,
  GetCustomerResponse,
  NextgenCustomer,
  TCCService,
} from '@/services/tcc/configurator'

export { CustomerStatus }
export type { Customer, NextgenCustomer }

export const getCustomers = async (): Promise<Customer[]> => {
  const data = await TCCService.GetCustomers({})
  return data.customers
}

export const getCustomer = async (
  customerId: string
): Promise<GetCustomerResponse> => {
  return TCCService.GetCustomer({ customerId })
}

export const getNextgenCustomers = async (
  searchMode: 'gcn' | 'name',
  query: string
): Promise<NextgenCustomer[]> => {
  const resp = await TCCService.GetNextgenCustomers({
    clientId: '',
    clientName: searchMode === 'name' ? query : '',
    gcn: searchMode === 'gcn' ? query : '',
  })

  return resp.customers ?? []
}

export const createCustomer = async (request: CreateCustomerRequest) => {
  return TCCService.CreateCustomer(request)
}
